
export default {
  props: {
    blok: {
      type: Object,
      default: () => {},
    },
  },

  methods: {
    ctaStyle() {
      const style = {}
      // if (this.blok.backgroundImage && this.blok.backgroundImage.filename) {
      //   style.backgroundImage = `url(${this.blok.backgroundImage.filename}/m/)`
      // }
      return style
    },
  },
}
